var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            color: "white",
            "rounded-lg": "",
            "close-on-content-click": false,
            "nudge-left": "300",
            "nudge-top": "-6",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "text-capitalize mr-4",
                          attrs: {
                            height: "40",
                            color: "primary",
                            rounded: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "label_essweb_approvalApplication_form_ApprovalBtnLabel"
                            )
                          ) +
                          " "
                      ),
                      _c("v-icon", { staticClass: "material-icons" }, [
                        _vm._v("arrow_drop_down"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0" },
            [
              _c(
                "v-card-text",
                { staticClass: "px-8" },
                [
                  _c("normalInputTextFiled", {
                    attrs: {
                      "text-area": "",
                      disabled: !_vm.matched,
                      maxlength: "500",
                      label: _vm.$t(
                        "label_essweb_approvalApplication_form_messageLabel"
                      ),
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                  _c(
                    "v-sheet",
                    {
                      staticClass:
                        "d-flex flex-row justify-space-around mt-2 flex-grow-1",
                    },
                    [
                      !(!_vm.matched || !_vm.canRevoke)
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "d-flex flex-column align-center mx-3 flex-grow-1",
                              attrs: { width: "55" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  class:
                                    _vm.matched && _vm.canRevoke
                                      ? "white--text"
                                      : "grey lighten-1 white--text ",
                                  style: {
                                    backgroundColor:
                                      _vm.matched && _vm.canRevoke
                                        ? "#ff5252"
                                        : "",
                                  },
                                  attrs: {
                                    icon: "",
                                    disabled: !_vm.matched || !_vm.canRevoke,
                                    rounded: "",
                                    width: "48",
                                    height: "48",
                                  },
                                  on: { click: _vm.toReject },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons white--text",
                                    },
                                    [_vm._v(" close ")]
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "text-capitalize",
                                  class:
                                    _vm.matched && _vm.canRevoke
                                      ? ""
                                      : "text--secondary text--lighten-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_approvalApplication_form_rejectLabbel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !(!_vm.matched || !_vm.canRollback)
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "d-flex flex-column align-center mx-3 flex-grow-1",
                              attrs: { width: "55" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  class:
                                    _vm.matched && _vm.canRollback
                                      ? "white--text black"
                                      : "grey lighten-1",
                                  attrs: {
                                    icon: "",
                                    rounded: "",
                                    disabled: !_vm.matched || !_vm.canRollback,
                                    width: "48",
                                    color: "white",
                                    height: "48",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.backApproval = true
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      size: "24",
                                      fill: "white",
                                      iconClass: "arrow_left_bottom",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "text-capitalize",
                                  class:
                                    _vm.matched && _vm.canRollback
                                      ? ""
                                      : "text--secondary text--lighten-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_approvalApplication_form_backLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      !(!_vm.matched || !_vm.canForward)
                        ? _c(
                            "v-sheet",
                            {
                              staticClass:
                                "d-flex flex-column align-center mx-3 flex-grow-1",
                              attrs: { width: "55" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  class:
                                    _vm.matched && _vm.canForward
                                      ? "white--text black"
                                      : "grey lighten-1 white--text",
                                  attrs: {
                                    icon: "",
                                    rounded: "",
                                    disabled: !_vm.matched || !_vm.canForward,
                                    width: "48",
                                    height: "48",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.forwardApproval = true
                                    },
                                  },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      size: "24",
                                      fill: "white",
                                      iconClass: "arrow_right_top",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "text-capitalize",
                                  class:
                                    _vm.matched && _vm.canForward
                                      ? ""
                                      : "text--secondary text--lighten-1",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_approvalApplication_form_forwardLabbel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "d-flex flex-column align-center mx-3 flex-grow-1",
                          attrs: { width: "55" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              class: _vm.matched
                                ? "white--text"
                                : "grey lighten-1 white--text",
                              style: {
                                backgroundColor: _vm.matched ? "#18a874" : "",
                              },
                              attrs: {
                                rounded: "",
                                loading: _vm.isLoading,
                                disabled: !_vm.matched || _vm.isLoading,
                                width: "48",
                                height: "48",
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.final_node || _vm.admin
                                    ? _vm.approveHandle([])
                                    : (_vm.showSender = true)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons white--text" },
                                [_vm._v(" send ")]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "text-capitalize",
                              class: _vm.matched
                                ? ""
                                : "text--secondary text--lighten-1",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_approvalApplication_form_approveLabel"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("forwardTo", {
        attrs: {
          show: _vm.forwardApproval,
          curUuid: _vm.curUuid,
          staff_uuid: _vm.staff_uuid,
        },
        on: {
          close: function ($event) {
            _vm.forwardApproval = false
          },
          forward: _vm.toForward,
        },
      }),
      _c("backTo", {
        attrs: { show: _vm.backApproval, curUuid: _vm.curUuid },
        on: {
          close: function ($event) {
            _vm.backApproval = false
          },
          back: _vm.toBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }